import { useEffect, useState } from "react";
import { DropDownMultiCheck } from "../DropDownMultiCheck";
import { TagService } from "../../../../services/TagService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function Tags({params}) {
    const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
    const [tagsList, setTagsList] = useState([]);

    useEffect(() => {
        TagService.getTagsList().then((data) => {
        setTagsList(data);
        });
    }, []);

    function setTags(list) {
        setSearchObject({ ...searchObject, tags: list });
    }

    return (
        <fieldset>
        <legend>{t("Tags")}</legend>
        <DropDownMultiCheck
            dataList={tagsList.map((x) => {
            return { id: x.id, description: x.name };
            })}
            selecteds={searchObject.tags}
            setSelecteds={setTags}
        />
        </fieldset>
    );
}